import React, { useState } from 'react';
import { Box } from '@mui/material';
import EsgListContainer from '../../containers/esgmng/EsgListContainer';
import EsgFormContainer from '../../containers/esgmng/EsgFormContainer';

const EsgMngTemplate = () => {
  const [type, setType] = useState('add');
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [searchData, setSearchData] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setData(null);
  };

  const handleAdd = () => {
    setType('add');
    setData(null);
    setOpen(true);
  };

  const selectedBoard = (board) => {
    setType('edit');
    setData(board);
    setOpen(true);
  };

  const onSearch = (search) => {
    setSearchData(search);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', m: 1 }}>
      <EsgListContainer
        searchData={searchData}
        onSearch={onSearch}
        selectedBoard={selectedBoard}
        handleAdd={handleAdd}
      />
      <EsgFormContainer
        type={type}
        data={data}
        open={open}
        searchData={searchData}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default EsgMngTemplate;
